import { render, staticRenderFns } from "./CreateFeature.vue?vue&type=template&id=50e63266&scoped=true&lang=pug&"
import script from "./CreateFeature.vue?vue&type=script&lang=js&"
export * from "./CreateFeature.vue?vue&type=script&lang=js&"
import style0 from "./CreateFeature.vue?vue&type=style&index=0&id=50e63266&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e63266",
  null
  
)

export default component.exports